import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Home, Wrench, Mail } from "lucide-react";
import SEO from "@/components/SEO";

const SUGGESTED = [
  { label: "Home", desc: "Start over from the top.", to: "/", icon: Home, testid: "404-link-home" },
  { label: "Services", desc: "Gutters, guards, and roofing.", to: "/#services", icon: Wrench, testid: "404-link-services" },
  { label: "Contact", desc: "Get a free on site quote.", to: "/contact", icon: Mail, testid: "404-link-contact" },
];

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found" description="This page is not on the site anymore." path="/404" noindex />
      <section className="min-h-[70vh] flex items-center" data-testid="not-found-page">
        <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-24 w-full">
          <p className="overline mb-6">Error 404</p>
          <h1 className="font-display text-6xl md:text-8xl tracking-tightest leading-[0.9] mb-8">
            This page took the summer off.
          </h1>
          <p className="text-bone-300 text-lg max-w-lg mb-12">
            The link is broken or the page moved. Here are the three places most people are looking for.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-3xl">
            {SUGGESTED.map(({ label, desc, to, icon: Icon, testid }) => (
              <Link
                key={label}
                to={to}
                data-testid={testid}
                className="group border border-white/10 hover:border-copper-500 bg-ink-900 rounded-sm p-6 transition-colors duration-200"
              >
                <div className="flex items-center justify-between mb-4">
                  <Icon className="w-5 h-5 text-copper-500" strokeWidth={2} />
                  <ArrowUpRight className="w-4 h-4 text-bone-400 group-hover:text-copper-500 group-hover:rotate-45 transition-transform duration-300" />
                </div>
                <p className="font-heading font-semibold text-bone-50 mb-1">{label}</p>
                <p className="text-sm text-bone-400">{desc}</p>
              </Link>
            ))}
          </div>
          <Link
            to="/sitemap"
            data-testid="404-link-sitemap"
            className="inline-block mt-8 text-sm text-bone-400 hover:text-copper-500 underline"
          >
            Or browse the full HTML sitemap
          </Link>
        </div>
      </section>
    </>
  );
}

